<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data início" prop="data_inicio" :rules="[$requiredChange]" key="data_inicio">
              <el-date-picker v-model="dados.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data fim" prop="data_fim" :rules="[$requiredChange]" key="data_fim">
              <el-date-picker v-model="dados.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Itens do cardápio" titleIcon="fas fa-utensils">
          <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" class="u-text-right">
              <el-button type="primary" plain icon="el-icon-plus" @click="addItem">ADICIONAR ITEM</el-button>
            </el-col>
          </el-row>
          <div class="container-table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 100px;">Dia semana</th>
                  <th style="width: 130px;">Refeição</th>
                  <th style="width: 130px;">Modalidade</th>
                  <th style="width: 240px;">Receita</th>
                  <th>Descrição livre</th>
                  <th style="width: 120px;" class="u-text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in itens" :key="idx">
                  <td>
                    <el-select v-model="item.dia_semana" placeholder="Selecione">
                      <el-option v-for="d in diasSemana" :key="d.value" :label="d.label" :value="d.value"></el-option>
                    </el-select>
                  </td>
                  <td><el-input v-model="item.refeicao" maxlength="50"></el-input></td>
                  <td>
                    <el-select v-model="item.modalidade" clearable>
                      <el-option label="CRECHE" value="creche"></el-option>
                      <el-option label="PRÉ-ESCOLA" value="pre"></el-option>
                      <el-option label="FUNDAMENTAL" value="fundamental"></el-option>
                      <el-option label="EJA" value="eja"></el-option>
                      <el-option label="INTEGRAL" value="integral"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-select v-model="item.receita_id" placeholder="pesquisar" filterable remote clearable :remote-method="(q) => searchReceita(q, idx)" :loading="item.loadingReceita">
                      <el-option v-for="r in item.receitas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
                    </el-select>
                  </td>
                  <td><el-input v-model="item.descricao" maxlength="500"></el-input></td>
                  <td class="u-text-center">
                    <el-button v-if="edit && item.id" @click="saveItem(item)" type="info" icon="el-icon-check" size="mini" plain title="Salvar item"></el-button>
                    <el-button class="u-ml-10" @click="removeItem(item, idx)" type="danger" icon="el-icon-delete" size="mini" plain title="Remover item"></el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-cardapio" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <!-- BLOCO U — item 18: substituição de alimento para aluno com restrição -->
    <div class="u-mt-30" v-if="dados.id">
      <h4 class="u-mb-10">Substituições do cardápio</h4>

      <el-alert class="u-mb-10" type="info" :closable="false" show-icon
        title="A substituição atende um aluno específico ou todos os alunos que tenham uma determinada restrição. O sistema recusa substituto que recaia na mesma restrição."></el-alert>

      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="24" :sm="10">
          <el-select v-model="substItem" placeholder="Item do cardápio" clearable style="width:100%" @change="carregarSubstituicoes">
            <el-option v-for="(it, i) in itens" :key="i" :value="it.id"
                       :label="(it.refeicao || 'refeição') + ' — ' + (it.descricao || '')" :disabled="!it.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="6" class="u-text-right">
          <el-button type="primary" :disabled="!substItem || !podeSubstituir" @click="dialogSubst = true">NOVA SUBSTITUIÇÃO</el-button>
        </el-col>
      </el-row>

      <table class="table table-striped" v-if="substituicoes.length">
        <thead>
          <tr>
            <th>Substituto</th>
            <th style="width:150px;">Motivo</th>
            <th style="width:170px;">Alcance</th>
            <th class="hidden-mobile">Observação</th>
            <th style="width:90px;" class="u-text-center" v-if="podeSubstituir">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in substituicoes" :key="s.id">
            <td>{{ s.alimento_substituto_id ? ('Alimento #' + s.alimento_substituto_id) : ('Receita #' + s.receita_substituta_id) }}</td>
            <td>{{ s.motivo }}</td>
            <td>{{ s.aluno_id ? ('aluno #' + s.aluno_id) : ('restrição #' + s.restricao_id) }}</td>
            <td class="hidden-mobile u-fs-12">{{ s.observacao || '—' }}</td>
            <td class="u-text-center" v-if="podeSubstituir">
              <el-button @click="excluirSubstituicao(s.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="substItem" class="u-fs-12">Nenhuma substituição para este item.</div>

      <el-dialog title="Nova substituição" :visible.sync="dialogSubst" width="560px">
        <el-form :model="novaSubst" label-position="top">
          <el-form-item label="Alimento substituto">
            <el-select v-model="novaSubst.alimento_substituto_id" filterable remote reserve-keyword
                       placeholder="Buscar alimento" :remote-method="buscarAlimentoSubst" :loading="buscandoSubst" style="width:100%">
              <el-option v-for="a in alimentosSubst" :key="a.id" :label="a.nome" :value="a.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Motivo">
            <el-select v-model="novaSubst.motivo" style="width:100%">
              <el-option label="Restrição alimentar" value="restricao"></el-option>
              <el-option label="Alergia" value="alergia"></el-option>
              <el-option label="Indisponibilidade" value="indisponibilidade"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Alcance">
            <el-radio-group v-model="alcanceSubst">
              <el-radio label="aluno">Um aluno</el-radio>
              <el-radio label="restricao">Todos com uma restrição</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="Aluno" v-if="alcanceSubst === 'aluno'">
            <el-select v-model="novaSubst.aluno_id" filterable remote reserve-keyword placeholder="Buscar aluno"
                       :remote-method="buscarAlunoSubst" :loading="buscandoAlunoSubst" style="width:100%">
              <el-option v-for="a in alunosSubst" :key="a.id" :label="a.nome" :value="a.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="ID da restrição" v-else>
            <el-input v-model="novaSubst.restricao_id" placeholder="Identificador da restrição"></el-input>
          </el-form-item>

          <el-form-item label="Observação">
            <el-input v-model="novaSubst.observacao" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogSubst = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="salvarSubstituicao">SALVAR</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    diasSemana: [
      { label: 'DOM', value: 0 },
      { label: 'SEG', value: 1 },
      { label: 'TER', value: 2 },
      { label: 'QUA', value: 3 },
      { label: 'QUI', value: 4 },
      { label: 'SEX', value: 5 },
      { label: 'SÁB', value: 6 },
    ],
    dados: { id: '', instituicao_id: '', data_inicio: '', data_fim: '', descricao: '' },
    substItem: '', substituicoes: [], dialogSubst: false, alcanceSubst: 'aluno',
    alimentosSubst: [], buscandoSubst: false, alunosSubst: [], buscandoAlunoSubst: false,
    novaSubst: { alimento_substituto_id: '', motivo: 'restricao', aluno_id: '', restricao_id: '', observacao: '' },
    itens: []
  }),
  computed: {
    podeSubstituir () { return [0,1,4,5,7,12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    carregarSubstituicoes () {
      if (!this.substItem) { this.substituicoes = []; return }
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-substituicao/item/` + this.substItem, this.$store.getters.getHeaderAuth)
        .then(r => { this.substituicoes = (r.data && r.data.erro) ? [] : r.data })
        .catch(() => { this.substituicoes = [] })
    },
    buscarAlimentoSubst (q) {
      if (!q || q.length < 2) { this.alimentosSubst = []; return }
      this.buscandoSubst = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
        .then(r => { this.alimentosSubst = Array.isArray(r.data) ? r.data : (r.data.data || []); this.buscandoSubst = false })
        .catch(() => { this.buscandoSubst = false })
    },
    buscarAlunoSubst (q) {
      if (!q || q.length < 3) { this.alunosSubst = []; return }
      this.buscandoAlunoSubst = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
        .then(r => { this.alunosSubst = Array.isArray(r.data) ? r.data : (r.data.data || []); this.buscandoAlunoSubst = false })
        .catch(() => { this.buscandoAlunoSubst = false })
    },
    salvarSubstituicao () {
      const p = Object.assign({ cardapio_item_id: this.substItem }, this.novaSubst)
      if (this.alcanceSubst === 'aluno') { p.restricao_id = '' } else { p.aluno_id = '' }
      window.eventBus.$emit('loading', true)
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-substituicao/store`, p, this.$store.getters.getHeaderAuth)
        .then(r => {
          window.eventBus.$emit('loading', false)
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.dialogSubst = false
          this.carregarSubstituicoes()
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    excluirSubstituicao (id) {
      window.eventBus.$emit('loading', true)
      this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-substituicao/delete/` + id, this.$store.getters.getHeaderAuth)
        .then(r => {
          window.eventBus.$emit('loading', false)
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.carregarSubstituicoes()
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio/getById/` + id, this.$store.getters.getHeaderAuth)
      this.dados = JSON.parse(JSON.stringify(res.data.cardapio))
      // Semeia `receitas` com a receita já vinculada, para o el-select exibir o nome (e não o id) na edição.
      this.itens = (res.data.itens || []).map(i => Object.assign({}, i, { receitas: i.receita ? [i.receita] : [], loadingReceita: false }))
    },
    addItem () {
      this.itens.push({ id: '', cardapio_id: '', dia_semana: 1, refeicao: '', modalidade: '', receita_id: '', descricao: '', receitas: [], loadingReceita: false })
    },
    searchReceita (query, idx) {
      if (!query || query.length < 2) { this.itens[idx].receitas = []; return }
      this.itens[idx].loadingReceita = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/receita/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.itens[idx].receitas = JSON.parse(JSON.stringify(res.data)); this.itens[idx].loadingReceita = false })
        .catch(e => { this.itens[idx].loadingReceita = false; this.$store.commit('throwException', e) })
    },
    async removeItem (item, idx) {
      if (this.edit && item.id) {
        await this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-item/delete/` + item.id, this.$store.getters.getHeaderAuth)
      }
      this.itens.splice(idx, 1)
    },
    async saveItem (item) {
      const payload = Object.assign({}, item, { cardapio_id: this.dados.id })
      if (item.id) {
        await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-item/update/` + item.id, payload, this.$store.getters.getHeaderAuth)
      } else {
        const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-item/store`, payload, this.$store.getters.getHeaderAuth)
        item.id = res.data.id
      }
      window.eventBus.$emit('alert', { msg: 'Item salvo.', type: 'success' })
    },
    onSubmit () {
      document.getElementById("btn-cardapio").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        const inst = this.$store.state.config.instituicao
        if (!inst || !inst.id) {
          return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
        }
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = inst.id
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
            for (const it of this.itens) {
              if (!it.id && (it.refeicao || it.descricao || it.receita_id)) {
                const novoItem = { dia_semana: it.dia_semana, refeicao: it.refeicao, modalidade: it.modalidade, receita_id: it.receita_id || null, descricao: it.descricao, cardapio_id: this.dados.id }
                await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio-item/store`, novoItem, this.$store.getters.getHeaderAuth)
              }
            }
          } else {
            const payload = Object.assign({}, this.dados, { itens: this.itens.map(i => ({ dia_semana: i.dia_semana, refeicao: i.refeicao, modalidade: i.modalidade, receita_id: i.receita_id || null, descricao: i.descricao })) })
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio/store`, payload, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitCardapio')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        } else if (!this.itens.length) {
          this.addItem()
        }
      }
    }
  }
}
</script>

